import client from '@/apis/http-client'
import Vue from 'vue'
import qs from 'qs'

const pathUrl = `/por/api/contact-messages`
const useMockData = false

const mockMessages = [
  {
    id: 'd2bc95f8-17d1-46ba-b2ce-b0e996f405c1',
    org_codename: 'psuv',
    form_type: 'contact',
    first_name: 'Somchai',
    last_name: 'Jaidee',
    locale: 'th',
    phone: '0812345678',
    email: 'somchai@email.com',
    message: 'I would like to inquire about orthopedic department operating hours.',
    source_page: 'https://www.princsuvarnabhumi.com/contact',
    status: 'new',
    admin_notes: '',
    consent_accepted: true,
    consent_policy_version: 'pdpa-2026-01',
    user_ip: '203.0.113.195',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_5 like Mac OS X)',
    created_at: '2026-09-10T10:22:00+07:00'
  },
  {
    id: '82ae5a6f-4238-42fc-9dc5-0f4b74f6e4dd',
    org_codename: 'pkkp',
    form_type: 'feedback',
    first_name: 'Nicha',
    last_name: 'K.',
    locale: 'th',
    phone: '0891234567',
    email: 'nicha@email.com',
    message: 'Service is good but waiting time at registration was long.',
    source_page: 'https://www.princkhonkaen.com/feedback',
    status: 'sent',
    admin_notes: 'Forwarded to front desk team for service improvement.',
    consent_accepted: true,
    consent_policy_version: 'pdpa-2026-01',
    user_ip: '203.0.113.196',
    user_agent: 'Mozilla/5.0 (Linux; Android 14)',
    created_at: '2026-09-09T15:40:00+07:00'
  },
  {
    id: 'b4f4b64c-4b4e-4bd1-9d7f-c6fd7e13f1df',
    org_codename: 'psri',
    form_type: 'complaint',
    first_name: 'Kritsada',
    last_name: 'T.',
    locale: 'th',
    phone: '0862223344',
    email: 'kritsada@email.com',
    message: 'I had difficulty contacting the billing desk after discharge.',
    source_page: 'https://www.princsrisaket.com/contact-us',
    status: 'resolved',
    admin_notes: 'Resolved after callback and billing clarification.',
    consent_accepted: true,
    consent_policy_version: 'pdpa-2026-01',
    user_ip: '203.0.113.197',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    created_at: '2026-09-08T09:05:00+07:00'
  },
  {
    id: '21f80695-f2ab-4c8a-a035-c700617f7863',
    org_codename: 'psuv',
    form_type: 'feedback',
    first_name: 'Pimnipa',
    last_name: 'R.',
    locale: 'en',
    phone: '0953332221',
    email: 'pimnipa@email.com',
    message: 'Would appreciate more parking signage near emergency entrance.',
    source_page: 'https://www.princsuvarnabhumi.com/feedback',
    status: 'failed',
    admin_notes: 'Notification queue failed once, waiting retry.',
    consent_accepted: true,
    consent_policy_version: 'pdpa-2026-01',
    user_ip: '203.0.113.198',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 14_5)',
    created_at: '2026-09-07T20:30:00+07:00'
  }
]

const normalizeMessage = (item) => {
  const firstName = item.first_name || (item.full_name || '').split(' ')[0] || ''
  const lastName = item.last_name || (item.full_name || '').split(' ').slice(1).join(' ') || ''

  return {
    ...item,
    org_codename: item.org_codename || item.org_code || null,
    first_name: firstName,
    last_name: lastName,
    locale: item.locale || 'th'
  }
}

const defaultState = () => ({
  currentPage: 1,
  pageSize: 25,
  total: 0,
  sortBy: 'created_at',
  sortDesc: 'DESC',
  textSearch: '',
  filterFormType: '',
  filterStatus: '',
  filterOrgCode: '',
  isLoading: false,
  isActivityLoading: false,
  list: [],
  selectedMessage: null,
  activityLogs: [],
  currentActivityMessageId: null,
  filterOptions: {
    form_types: [],
    statuses: []
  }
})

let state = defaultState()

const actions = {
  resetList({commit}) {
    commit('RESET_LIST_STATE')
  },
  setPage({commit}, page) {
    commit('SET_PAGE', page)
  },
  setPageSize({commit}, size) {
    commit('SET_PAGE_SIZE', size)
  },
  setTextSearch({commit}, text) {
    if (text === state.textSearch) return
    commit('SET_TEXT_SEARCH', text)
  },
  setFieldSort({commit}, field) {
    commit('SET_FIELD_SORT', field || defaultState().sortBy)
  },
  setSort({commit}, sort) {
    commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
  },
  setFilterFormType({commit}, formType) {
    commit('SET_FILTER_FORM_TYPE', formType)
  },
  setFilterStatus({commit}, status) {
    commit('SET_FILTER_STATUS', status)
  },
  setFilterOrgCode({commit}, orgCode) {
    commit('SET_FILTER_ORG_CODE', orgCode)
  },
  setSelectedMessage({commit}, message) {
    commit('SET_SELECTED_MESSAGE', message ? normalizeMessage(message) : null)
  },
  async fetchActivityLogs({commit, state}, id) {
    commit('SET_CURRENT_ACTIVITY_MESSAGE_ID', id)
    commit('SET_ACTIVITY_LOGS', [])
    commit('SET_IS_ACTIVITY_LOADING', true)
    try {
      if (useMockData) {
        if (state.currentActivityMessageId === id) {
          commit('SET_ACTIVITY_LOGS', [])
        }
        commit('SET_IS_ACTIVITY_LOADING', false)
        return
      }

      const response = await client.secureHttpClient.get(`${pathUrl}/${id}/activity-logs`)
      const resData = response && response.data ? response.data : {}
      const logs = resData.results || []
      if (state.currentActivityMessageId === id) {
        commit('SET_ACTIVITY_LOGS', logs)
      }
    } catch (e) {
      Vue.$log.error(e)
      if (state.currentActivityMessageId === id) {
        commit('SET_ACTIVITY_LOGS', [])
      }
    } finally {
      if (state.currentActivityMessageId === id) {
        commit('SET_IS_ACTIVITY_LOADING', false)
      }
    }
  },
  async fetchFilterOptions({commit}) {
    try {
      const response = await client.secureHttpClient.get(`${pathUrl}/filter-options`)
      const resData = response && response.data ? response.data : {}
      commit('SET_FILTER_OPTIONS', {
        form_types: resData.form_types || [],
        statuses: resData.statuses || []
      })
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_FILTER_OPTIONS', {
        form_types: [],
        statuses: []
      })
    }
  },
  async fetch({commit}) {
    commit('SET_IS_LOADING', true)

    const {
      currentPage,
      pageSize,
      sortBy,
      sortDesc,
      textSearch,
      filterFormType,
      filterStatus,
      filterOrgCode
    } = state

    try {
      if (useMockData) {
        const data = getMockResult({
          page: currentPage,
          limit: pageSize,
          orderBy: sortBy,
          sort: sortDesc,
          search: textSearch,
          form_type: filterFormType,
          status: filterStatus,
          org_codename: filterOrgCode
        })
        commit('SET_LIST', data.results)
        commit('SET_TOTAL', data.total)
      } else {
        const params = {
          page: currentPage,
          limit: pageSize,
          orderBy: sortBy,
          sort: sortDesc,
          search: textSearch,
          form_type: filterFormType,
          status: filterStatus,
          org_codename: filterOrgCode
        }
        const response = await client.secureHttpClient.get(pathUrl, {
          params,
          paramsSerializer: localParams => qs.stringify(localParams, {encode: false})
        })
        const resData = response && response.data ? response.data : {}
        const list = resData.results || resData.data || (Array.isArray(resData) ? resData : [])
        const total = resData.total !== undefined ? resData.total : list.length
        commit('SET_LIST', list.map(normalizeMessage))
        commit('SET_TOTAL', total)
      }
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_LIST', [])
      commit('SET_TOTAL', 0)
    }

    commit('SET_IS_LOADING', false)
  },
  async updateMessage({commit}, payload) {
    try {
      if (useMockData) {
        const target = mockMessages.find(item => item.id === payload.id)
        if (target) {
          target.status = payload.status
          target.admin_notes = payload.admin_notes
        }
      } else {
        await client.secureHttpClient.put(`${pathUrl}/${payload.id}`, {
          status: payload.status,
          admin_notes: payload.admin_notes
        })
      }

      const selected = state.list.find(item => item.id === payload.id)
      if (selected) {
        commit('UPDATE_LIST_ITEM', {
          id: payload.id,
          status: payload.status,
          admin_notes: payload.admin_notes
        })
        commit('SET_SELECTED_MESSAGE', {
          ...selected,
          status: payload.status,
          admin_notes: payload.admin_notes
        })
      }

      return true
    } catch (e) {
      Vue.$log.error(e)
      return false
    }
  }
}

const mutations = {
  RESET_LIST_STATE(state) {
    state.currentPage = defaultState().currentPage
    state.pageSize = defaultState().pageSize
    state.textSearch = defaultState().textSearch
    state.sortBy = defaultState().sortBy
    state.sortDesc = defaultState().sortDesc
    state.filterFormType = defaultState().filterFormType
    state.filterStatus = defaultState().filterStatus
    state.filterOrgCode = defaultState().filterOrgCode
    state.list = []
    state.total = 0
    state.activityLogs = []
    state.currentActivityMessageId = null
    state.isActivityLoading = false
    state.filterOptions = defaultState().filterOptions
  },
  SET_PAGE(state, page) {
    state.currentPage = page
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size
  },
  SET_TEXT_SEARCH(state, text) {
    state.textSearch = text
  },
  SET_FIELD_SORT(state, field) {
    state.sortBy = field
  },
  SET_SORT(state, sort) {
    state.sortDesc = sort
  },
  SET_FILTER_FORM_TYPE(state, formType) {
    state.filterFormType = formType
  },
  SET_FILTER_STATUS(state, status) {
    state.filterStatus = status
  },
  SET_FILTER_ORG_CODE(state, orgCode) {
    state.filterOrgCode = orgCode
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_IS_ACTIVITY_LOADING(state, isActivityLoading) {
    state.isActivityLoading = isActivityLoading
  },
  SET_LIST(state, list) {
    state.list = list.map(normalizeMessage)
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
  SET_SELECTED_MESSAGE(state, message) {
    state.selectedMessage = message
  },
  SET_ACTIVITY_LOGS(state, logs) {
    state.activityLogs = logs
  },
  SET_CURRENT_ACTIVITY_MESSAGE_ID(state, id) {
    state.currentActivityMessageId = id
  },
  SET_FILTER_OPTIONS(state, options) {
    state.filterOptions = options
  },
  UPDATE_LIST_ITEM(state, payload) {
    state.list = state.list.map((item) => {
      if (item.id !== payload.id) return item
      return {
        ...item,
        status: payload.status,
        admin_notes: payload.admin_notes
      }
    })
  }
}

const getMockResult = params => {
  const {
    page,
    limit,
    orderBy,
    sort,
    search,
    form_type,
    status,
    org_codename
  } = params

  let data = [...mockMessages]

  if (search) {
    const term = search.toLowerCase()
    data = data.filter(item => {
      return (
        `${item.first_name || ''} ${item.last_name || ''}`.toLowerCase().includes(term) ||
        item.email.toLowerCase().includes(term) ||
        item.phone.toLowerCase().includes(term) ||
        (item.org_codename || '').toLowerCase().includes(term)
      )
    })
  }

  if (form_type) {
    data = data.filter(item => item.form_type === form_type)
  }

  if (status) {
    data = data.filter(item => item.status === status)
  }

  if (org_codename) {
    data = data.filter(item => item.org_codename === org_codename)
  }

  data.sort((a, b) => {
    const current = `${a[orderBy] || ''}`
    const next = `${b[orderBy] || ''}`
    if (sort === 'ASC') {
      return current.localeCompare(next)
    }
    return next.localeCompare(current)
  })

  const start = (page - 1) * limit
  const end = start + limit

  return {
    total: data.length,
    results: data.slice(start, end)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
